import { render, staticRenderFns } from "./SettingsPaymentProviders.vue?vue&type=template&id=4db411f4"
import script from "./SettingsPaymentProviders.vue?vue&type=script&lang=js"
export * from "./SettingsPaymentProviders.vue?vue&type=script&lang=js"
import style0 from "./SettingsPaymentProviders.vue?vue&type=style&index=0&id=4db411f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports